import { Injectable } from '@angular/core';
import { TaskType } from '../../../../core/entities/task/task-type';
import { ApolloService } from '../../../../core/services/apollo.service';
import { Observable, of, switchMap, take } from 'rxjs';
import * as fromGraphQl from './graphql';
/**
 * The models service.
 */
@Injectable()
export class TaskTypeService {
  constructor(private apolloService: ApolloService) {}

  public getTaskTypes(): Observable<TaskType[]> {
    return this.apolloService.query<fromGraphQl.GetTaskTypesResponse>(
      fromGraphQl.GET_TASK_TYPES_QUERY,
      { filter: { isActive: true } }
    ).pipe(
      take(1),
      switchMap((result) => {
        return of(result.data.getTaskTypes);
      })
    );
  }

}
